import { put, takeLatest, call } from "redux-saga/effects";
import {
	setNotifications,
	getNotificationsAsync,
	readNotificationAsync,
	readAllNotificationsAsync,
	getTotalUnreadNotificationsAsync,
	setTotalUnreadNotifications,
	setAllNotificationsAsRead,
} from "./notification.slice";
import { message } from "antd";
import api from "service/apiService";
import { translate } from "utils";

// Get all notifications
function* getNotifcationsSaga(action: any) {
	const { query, isNewNotifications, returnResult } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get("/notifications", query);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		returnResult(true);
		yield put({
			type: setNotifications.type,
			payload: { data: response.data.data, isNewNotifications },
		});
	} else {
		message.error(translate(error.message));
	}
}
function* watchGetNotifications() {
	yield takeLatest(getNotificationsAsync, getNotifcationsSaga);
}

function* readNotificationSaga(action: any) {
	const { id } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.put(`/notifications/${id}`, {
				read: true,
			});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: getTotalUnreadNotificationsAsync.type, payload: {} });
	} else {
		message.error(translate(error.message));
	}
}

function* watchReadNotification() {
	yield takeLatest(readNotificationAsync, readNotificationSaga);
}

function* readAllNotificationsSaga() {
	yield call(async () => {
		await api.put("/notifications/clear", {});
	});
	yield put({ type: setAllNotificationsAsRead.type, payload: {} });
	yield put({ type: getTotalUnreadNotificationsAsync.type, payload: {} });
}

function* watchReadAllNotifications() {
	yield takeLatest(readAllNotificationsAsync, readAllNotificationsSaga);
}

function* getTotalUnreadNotificationsSaga() {
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get(
				"/notifications/count",
				{

					read: false
		
				}
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({
			type: setTotalUnreadNotifications.type,
			payload: response.data.data,
		});
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetTotalUnreadNotifications() {
	yield takeLatest(
		getTotalUnreadNotificationsAsync,
		getTotalUnreadNotificationsSaga,
	);
}

const customerSaga = [
	watchGetNotifications(),
	watchReadNotification(),
	watchReadAllNotifications(),
	watchGetTotalUnreadNotifications(),
];
export default customerSaga;
